import { Injectable, NgZone } from '@angular/core';
import firebase from 'firebase/app';
import { IUser } from "../models/user";
import { Router } from "@angular/router";
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { BehaviorSubject } from 'rxjs';
import { AdmobService } from './admob.service';

@Injectable({
  providedIn: 'root'
})

export class AuthenticationService {
  userData: any;
  authState = new BehaviorSubject(true);

  constructor(
    public afStore: AngularFirestore,
    public ngFireAuth: AngularFireAuth,
    public router: Router,
    public ngZone: NgZone,
    private admobService: AdmobService
  ) {
    this.ngFireAuth.authState.subscribe(user => {
      if (user) {
        this.userData = user;
        localStorage.setItem('user', JSON.stringify(this.userData));
        this.authState.next(true);
      } else {
        localStorage.setItem('user', null);
      }
      console.log('ngFireAuth.authState', JSON.parse(localStorage.getItem('user')))
    })
  }

  // Login in with email/password
  signIn(email, password) {
    return this.ngFireAuth.signInWithEmailAndPassword(email, password)
  }

  // Register user with email/password
  registerUser(email, password) {
    return this.ngFireAuth.createUserWithEmailAndPassword(email, password)
  }

  // Email verification when new user register
  async sendVerificationMail() {
    return (await this.ngFireAuth.currentUser).sendEmailVerification()
  }

  // Recover password
  recoverPassword(passwordResetEmail) {
    return this.ngFireAuth.sendPasswordResetEmail(passwordResetEmail);
  }

  // Returns true when user is logged in
  get isLoggedIn(): boolean {
    const user = JSON.parse(localStorage.getItem('user'));
    return (user !== null && user.emailVerified !== false) ? true : false;
  }

  // Returns true when user's email is verified
  get isEmailVerified(): boolean {
    const user = JSON.parse(localStorage.getItem('user'));
    return (user.emailVerified !== false) ? true : false;
  }

  getCurrentUserId(): string {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user !== null)
      return user.uid;

    return null;
  }

  getCurrentUserEmail(): string {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user !== null)
      return user.email;

    return null;
  }

  getGoogleAuthProvider() {
    return (new firebase.auth.GoogleAuthProvider())
  }

  getFacebookAuthProvider() {
    return (new firebase.auth.FacebookAuthProvider())
  }

  LoginWithAuthProvider(provider): Promise<firebase.auth.UserCredential> {
    return this.ngFireAuth.signInWithPopup(provider)
  }

  linkProviderAccount(error: any) {
    this.ngFireAuth.fetchSignInMethodsForEmail(error.email)
      .then(providers => {
        console.log('login providers for', error.email, providers)
        //providers returns this array -> ["google.com"]
        if (providers.includes('google.com')) {
          // only support link to exisitng google provider
          var provider = new firebase.auth.GoogleAuthProvider();
          provider.setCustomParameters({ login_hint: error.email });
          this.ngFireAuth.signInWithPopup(provider)
            .then(result => {
              result.user.linkWithCredential(error.credential).then(linkCred => {
                this.setUserData(linkCred.user);
              })
            })
            .catch(error => console.log(error))
        }
      })
  }

  // Store user in localStorage
  setUserData(user) {
    const userRef: AngularFirestoreDocument<any> = this.afStore.doc(`users/${user.uid}`);
    const userData: IUser = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      emailVerified: user.emailVerified
    }
    return userRef.set(userData, {
      merge: true
    })
  }

  // Sign-out 
  signOut() {
    return this.ngFireAuth.signOut().then(() => {
      localStorage.removeItem('user');
      this.admobService.enableAdmob();
      this.router.navigate(['login']);
      this.authState.next(false);
    })
  }

  isAuthenticated() {
    return this.authState.value;
  }
}